// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2aUUd","consentsList":"PatientConsents_consentsList__2VAT4","consentsListEmpty":"PatientConsents_consentsListEmpty__1BhuM"};